import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, NavParams, IonSearchbar, Platform, AlertController } from '@ionic/angular';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { Constants } from 'app/utility/constants';


@Component({
    selector: 'select-list-modal',
    templateUrl: './select-list-modal.component.html',
    styleUrls: ['./select-list-modal.component.scss'],
    standalone: false
})
export class SelectListModalComponent implements OnInit
{

    @Input() id: string;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() items: ListItemModel[];

    @Input() selectAllLabel: string;
    @Input() selectedValue: string;
    @Input() showBoxes: boolean = false;
    @Input() displayType: string;
    @Input() allowRefresh: boolean = false;

    @Input() selectedItem: ListItemModel;
    @Input() selectedItemId: string;

    /*multiselect*/
    @Input() multiSelect: boolean = false;
    @Input() selectedItemIds: string[];

    @Input() allowAdd: boolean = false;
    @Input() codeLookupList: ListItemModel[];

    @Input() allowAddCode: boolean = false;
    @Input() codeCaption: string = '';

    @Input() allowAddReference: boolean = false;
    @Input() referenceCaption: string = '';

    @Input() allowAddCustomField1: boolean = false;
    @Input() customField1Caption: string = '';

    @Input() allowClear: boolean = false;
    @Input() forceDisableAllowClear: boolean = false;

    filteredItems: ListItemModel[];
    originalSelectedItems: ListItemModel[];
    originalSelectedItemIds: string[];
    @ViewChild('searchbar') searchbar: IonSearchbar;

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        private platform: Platform,
        public alertController: AlertController
    )
    {


    }

    ngOnInit()
    {
        this.originalSelectedItemIds = Object.assign([], this.selectedItemIds);
        if (!this.selectedItemIds) this.selectedItemIds = [];
        this.filteredItems = this.items;

        if (!this.multiSelect && this.filteredItems && this.filteredItems.length > 0)
        {
            var firstItem = this.filteredItems[0];

            if (firstItem.id != Constants.EmptyGuid && !firstItem.name.includes("All") && !firstItem.name.includes("None") &&
                !firstItem.name.includes("Any") && firstItem.name != "-" && !this.forceDisableAllowClear)
            {
                this.allowClear = true;
            }
        }

        if (this.platform.width() > 990 && this.items && this.items.length)
        {
            setTimeout(() =>
            {
                this.searchbar.setFocus();
            }, 500);
        }
    }

    public dismissModal(multiselectSave: boolean = false)
    {
        if (this.multiSelect)
        {
            if (!multiselectSave)
            {
                this.selectedItemIds = Object.assign([], this.originalSelectedItemIds);
            }
            // console.log(this.originalSelectedItemIds);
            // console.log(this.selectedItemIds);

            this.modalController.dismiss({
                'changed': multiselectSave,
                'selectedItemIds': this.selectedItemIds, //Note: this is already changed in the parent as it's a reference
            });
        }
        else
        {
            // Dismiss the top modal returning some data object
            this.modalController.dismiss({
                'selectedItem': this.selectedItem,
                'selectedItemId': this.selectedItemId,
            });
        }
    }
    setSelectedItem(item: ListItemModel, emit: boolean): void
    {
        if (this.multiSelect)
        {
            // console.log(item);
            if (this.isSelected(item))
            {
                this.selectedItemIds.splice(this.selectedItemIds.indexOf(item.id), 1);
            }
            else
            {
                this.selectedItemIds.push(item.id);
            }

        }
        else
        {
            if (this.selectedItem != item)
            {
                this.selectedItem = item;
                this.selectedItemId = item.id;
            }

            if (emit)
            {
                this.dismissModal();
            }
        }
    }

    isSelected(item: ListItemModel)
    {
        if (this.multiSelect)
        {
            if (this.selectedItemIds && this.selectedItemIds.length > 0)
            {
                const selected = this.selectedItemIds.includes(item.id);
                return selected;
            }
            else
            {
                return false;
            }
        }
        else
        {
            return (item == this.selectedItem);
        }
    }

    getItemName(item: ListItemModel)
    {
        return item.name ? item.name : "-";
    }


    async doRefresh(ev: any)
    {
        setTimeout(() =>
        {
            ev.target.complete();
            this.modalController.dismiss({
                'refresh': true
            });
        }, 250);
    }
    scrollTop: boolean = true;
    ionScrollEvent(ev: any)
    {
        var scrollTop = (ev.detail.scrollTop == 0);
        if (this.scrollTop != scrollTop)
        {
            this.scrollTop = scrollTop;
        }
    }

    onKeypress(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.handleChange(event);
        }
    }

    handleChange(event: any)
    {
        const query = event.target.value.toLowerCase();
        if (!query || query == '')
        {
            this.filteredItems = this.items;
            return;
        }

        this.filteredItems = this.items.filter(x => x.name.toLowerCase().indexOf(query) > -1);
    }

    async addNewItem()
    {
        let inputs = [];
        inputs.push(
            {
                type: 'text',
                name: 'caption',
                placeholder: 'Item caption',
                value: ''
            },
        );

        // console.log(this.codeLookupList);
        if (this.allowAddCode)
        {
            inputs.push({
                type: 'text',
                name: 'code',
                label: this.codeCaption,
                placeholder: this.codeCaption,
                value: ''
            });
        }

        if (this.allowAddReference)
        {
            inputs.push({
                type: 'text',
                name: 'reference',
                label: this.referenceCaption,
                placeholder: this.referenceCaption,
                value: ''
            });
        }
        if (this.allowAddCustomField1)
        {
            inputs.push({
                type: 'text',
                name: 'reference',
                label: this.customField1Caption,
                placeholder: this.customField1Caption,
                value: ''
            });
        }

        const alert = await this.alertController.create({
            header: 'Add new value',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: 'OK',
                    role: 'confirm',
                    handler: (x) =>
                    {
                        // console.log(x);
                        if (this.codeLookupList && this.codeLookupList.length > 0)
                        {
                            this.newItemParentSelect(x);
                        }
                        else
                        {
                            this.modalController.dismiss(x);
                        }
                    }
                }],
            inputs
        });

        await alert.present().then(() =>
        {
            const firstInput: any = document.querySelector('ion-alert input');
            firstInput.focus();
            return;
        });
    }

    async newItemParentSelect(data: any)
    {
        // console.log('newItemParentSelect');
        let inputs = [];
        if (this.codeLookupList)
        {
            this.codeLookupList.forEach(x =>
            {
                //push the lookup item as a radio input type
                inputs.push({
                    type: 'radio',
                    name: 'internalLookup',
                    label: x.name,
                    value: x.id
                });
            });

            const alert = await this.alertController.create({
                header: 'Maps to',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        handler: () => { }
                    },
                    {
                        text: 'OK',
                        role: 'confirm',
                        handler: (x) =>
                        {
                            data.code = x;
                            // console.log(data);
                            this.modalController.dismiss(data);
                        }
                    }],
                inputs
            });

            await alert.present();
        }
        else this.modalController.dismiss(data);

        //set data.code = x
    }

    clearSelection()
    {
        setTimeout(() =>
        {
            this.modalController.dismiss({
                'clear': true
            });
        }, 0);
    }

    selection: 'All' | 'None' | 'Partial';

    checkSelection()
    {
        if (!this.multiSelect || !this.items || !this.items.length) return false;
        const allIds = this.items.map(i => i.id).filter(id => !!id);
        if (!this.selectedItemIds || this.selectedItemIds.length == 0)
        {
            this.selection = 'None';
        }
        else if (allIds.every(id => this.selectedItemIds.includes(id)))
        {
            this.selection = 'All';
        }
        else
        {
            this.selection = 'Partial';
        }
        return this.selection;
    }

    toggleSelectAll(): void
    {
        if (!this.multiSelect || !this.items) return;
        if (this.selection == 'All')
        {
            //use setSelectedItem to ensure any side effects are handled
            this.items.forEach(i =>
            {
                if (this.isSelected(i)) this.setSelectedItem(i, false);
            });
        }
        else
        {
            this.items.forEach(i =>
            {
                if (!this.isSelected(i)) this.setSelectedItem(i, false);
            });
        }
    }
}
